import { gql } from '@apollo/client';

export const ALL_RESOURCES_QUERY = gql`
    query resources {
        resources {
            edges {
                node {
                    id
                    name
                    tagIds
                    description
                    isPublished
                    resourceLocalizations {
                        edges {
                            node {
                                id
                                localeCode
                                isDefault
                                resourceFileId
                                name
                                description
                                resourceFile {
                                    node {
                                        id
                                        genericFile
                                        lxpFile 
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }
`;
